
  const zeroValueAtc = document.querySelector("[js-zero-value-atc]")
  const zeroValueTemplate = document.querySelector(".template-zero-value")
  const zeroValueAtcAlert = document.querySelector("[js-zero-value-atc-alert]")
  document.addEventListener('rebuy:cart.change', (event) => { 
    
        if(zeroValueAtc && zeroValueTemplate){
            const count = event.detail.cart.itemCount();
            if(count >= 25){
                zeroValueAtc.classList.remove("disabled")
                zeroValueAtcAlert.classList.add("hidden")
            }else{
                zeroValueAtc.classList.add("disabled")
                zeroValueAtcAlert.classList.remove("hidden")
            }
        }
    });

    document.addEventListener('rebuy:smartcart.ready', (event) => {
        if(zeroValueAtc && zeroValueTemplate){
            const count = event.detail.smartcart.itemCount();
            if(count >= 25){
                zeroValueAtc.classList.remove("disabled")
                zeroValueAtcAlert.classList.add("hidden")
            }else{
                zeroValueAtc.classList.add("disabled")
                zeroValueAtcAlert.classList.remove("hidden")
            }
        }
    });

